import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faUserLock } from '@fortawesome/pro-light-svg-icons/faUserLock';
import { TypedMemo } from '../../../../../common/types';
import { songPageMessages } from '../songPageMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song page; each part uses its own slice of it */
import styles from '../SongPage.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongRemoveZoneProps {
  title: string;
  isClaimed: boolean;
  /** A member on a row with a master (owner decision 3, design f6): the owner note, no button. */
  isOwnerOnly: boolean;
  ownerEmail: string | null;
  onRemove: () => void;
}

/** The end of the page (design e1, f6): remove or un-claim the song, or the note that the owner does it. */
const SongRemoveZoneComponent: React.FC<SongRemoveZoneProps> = ({
  title,
  isClaimed,
  isOwnerOnly,
  ownerEmail,
  onRemove,
}) => {
  const intl = useIntl();

  if (isOwnerOnly) {
    return (
      <div className={styles.ownerNote} data-testid="song-page-owner-only">
        <FontAwesomeIcon icon={faUserLock} />
        <div className={styles.grow}>
          <b>{intl.formatMessage(songPageMessages.ownerOnlyTitle, { title })}</b>
          <small>
            {ownerEmail === null
              ? intl.formatMessage(songPageMessages.ownerOnlyBodyNoEmail)
              : intl.formatMessage(songPageMessages.ownerOnlyBody, { owner: ownerEmail })}
          </small>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.danger} data-testid="song-page-remove">
      <FontAwesomeIcon icon={faTrash} />
      <div className={styles.grow}>
        <b>
          {intl.formatMessage(isClaimed ? songPageMessages.removeUnclaimTitle : songPageMessages.removeTitle, {
            title,
          })}
        </b>
        <small>{intl.formatMessage(songPageMessages.removeBody)}</small>
      </div>
      <button type="button" className={styles.dangerButton} onClick={onRemove}>
        {intl.formatMessage(isClaimed ? songPageMessages.unclaimButton : songPageMessages.removeButton)}
      </button>
    </div>
  );
};

export const SongRemoveZone = TypedMemo(SongRemoveZoneComponent);
